import { CalendarDoc, DayHours, HolidayOrException, WorkingType, Calendar } from 'common';
import { ConcourseDb } from 'src/global/ConcourseDb';

export class CalendarUtils {
  static getCalendarsDb(projectId: string): ConcourseDb {
    return ConcourseDb.getInstance(`p-${projectId}-calendars`);
  }

  static getDefaultCalendar(): Calendar {
    return Calendar.getDefaultCalendar();
  }

  static parseCalendarDocs(docs: CalendarDoc[]): Calendar[] {
    const calendas = docs.map(doc => new Calendar(doc));
    calendas.forEach(calendar => calendar.setParent(calendas.find(c => c.id === calendar.parentId)));
    return calendas;
  }

  static getHoursPerWeek(calendarDoc: CalendarDoc): number {
    const days = [calendarDoc.sunday, calendarDoc.monday, calendarDoc.tuesday, calendarDoc.wednesday, calendarDoc.thursday, calendarDoc.friday, calendarDoc.saturday];

    let totalHours = 0;
    days.forEach(dayData => {
      if (dayData?.type === WorkingType.working && dayData?.hours?.length > 0) {
        dayData.hours.forEach(hour => {
          // Parse time strings like "08:00" to calculate hours
          const fromParts = hour.from.split(':');
          const toParts = hour.to.split(':');
          const fromHours = Number.parseFloat(fromParts[0]) + Number.parseFloat(fromParts[1]) / 60;
          const toHours = Number.parseFloat(toParts[0]) + Number.parseFloat(toParts[1]) / 60;
          totalHours += toHours - fromHours;
        });
      }
    });

    return totalHours;
  }

  /**
   * Calculate number of working days per week for a calendar
   * @param calendarDoc - The calendar document
   * @returns Number of working days in the week (0-7)
   */
  static getDaysPerWeek(calendarDoc: CalendarDoc): number {
    const days = [calendarDoc.sunday, calendarDoc.monday, calendarDoc.tuesday, calendarDoc.wednesday, calendarDoc.thursday, calendarDoc.friday, calendarDoc.saturday];

    return days.filter(dayData => dayData?.type === WorkingType.working && dayData?.hours?.length > 0).length;
  }

  static getHoursPerDay(calendarDoc: CalendarDoc): number {
    return this.getHoursPerWeek(calendarDoc) / this.getDaysPerWeek(calendarDoc) || 8;
  }
}
